var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from 'react';
import { Heading4 } from '../../../../elements';
import { observer } from 'mobx-react';
import { useState } from 'react';
import { Button, makeStyles, Grid, Card } from '@material-ui/core';
const useStyles = makeStyles({
    card: {
        minWidth: 275,
        maxWidth: 700,
        padding: '8px',
        margin: '8px',
        boxShadow: '0px 1px 10px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)'
    }
});
export const AccessOrderFiles = observer(({ reportStore, i18n, formatDate, getFilesMetaData, getFile }) => {
    const [files, setFiles] = useState([]);
    const style = useStyles('card');
    React.useEffect(() => {
        getFilesMetaData(reportStore.order.id).then(response => {
            if (response && response.length > 0) {
                response = response.sort((a, b) => {
                    if (a.purposeType < b.purposeType) {
                        return -1;
                    }
                    else if (a.purposeType > b.purposeType) {
                        return 1;
                    }
                    else
                        return 0;
                });
                setFiles(response);
            }
        });
    }, [reportStore.order.id]);
    const openPdfInNewTab = ({ id }) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const response = yield getFile(id);
            const blob = new Blob([response], { type: 'application/pdf' });
            const blobUrl = window.URL.createObjectURL(blob);
            window.open(blobUrl, '_blank');
        }
        catch (error) {
            console.error('Error fetching or processing the file:', error);
        }
    });
    const FileRow = ({ state, index, fileInfo }) => {
        var _a;
        let isNewCategory = false;
        if (((_a = state[index - 1]) === null || _a === void 0 ? void 0 : _a.purposeType) < fileInfo.purposeType || index === 0) {
            isNewCategory = true;
        }
        return (React.createElement(React.Fragment, null,
            isNewCategory && (React.createElement("h3", null, i18n(`fileCategory.${fileInfo.purposeType}`))),
            React.createElement(Grid, { container: true, item: true, direction: "row", xs: 12 },
                React.createElement(Grid, { item: true, xs: 3 },
                    React.createElement(Button, { variant: "contained", color: "primary", onClick: e => openPdfInNewTab(fileInfo) }, i18n('common.view'))),
                React.createElement(Grid, { item: true, xs: 9 },
                    React.createElement("p", null, fileInfo.originalFilename)))));
    };
    return (React.createElement(Grid, { container: true, direction: "column", spacing: 2 },
        React.createElement(Card, { className: style.card }, files.length ? (files.map((fileInfo, index, state) => (React.createElement(FileRow, Object.assign({ key: fileInfo.id }, { fileInfo, index, state }))))) : (React.createElement("p", null, i18n('common.noAttachments'))))));
});
const AttachmentsSection = ({ reportStore, i18n, formatDate, getFilesMetaData, getFile }) => {
    return (React.createElement("div", { className: 'ReadReportContent__Section', id: 'attachments' },
        React.createElement(Heading4, null, i18n('checkpoint.attachment')),
        React.createElement(AccessOrderFiles, Object.assign({}, { reportStore, i18n, formatDate, getFilesMetaData, getFile }))));
};
export default AttachmentsSection;
